/* eslint-disable sonarjs/cognitive-complexity */
import { useHistory } from 'react-router-dom';
import { useLogger } from '@hooks';
import { noFlowPath, Routes, ROUTES } from './navigation.paths';
import { useNavigationStore, useNavigationStep } from '@store';
import { CoreHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$helpers';
import { getSessionStorage } from '@helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
interface NavigationOutput {
	back: () => void;
	gotoHome: () => void;
	navigate: (route: Routes) => void;
	next: () => void;
	navigateCustomUrl: (url: string) => void;
	conclusionIziBizi: () => void;
	exit: () => void;
}

export const useNavigation = (): NavigationOutput => {
	const history = useHistory();
	const t = useTranslation();
	const logger = useLogger();
	const { flow: flowTypeStore } = useNavigationStore();
	const { current: currentStep, previous: previousStep, setNavigationStep, getFlow } = useNavigationStep();
	const { flow: flowPath } = getFlow(currentStep);

	const back = () => {
		let currentPath = '';
		let prevPath = '';

		if (flowTypeStore === 'integratedSolution' && currentStep === ROUTES.integratedSolutionSelectSolution) {
			currentPath = ROUTES.subscriptionSelectPlan;
		} else if (flowTypeStore === 'noFlow') {
			const { flow: paths } = getFlow(previousStep as string);
			const index = paths.indexOf(previousStep as string);
			currentPath = paths[index];
			prevPath = paths[index - 1];
		} else {
			if (flowPath.includes(currentStep)) {
				const index = flowPath.indexOf(currentStep);
				currentPath = flowPath[index - 1];
				prevPath = currentStep;
			} else {
				const prev = !CoreHelper.isNullOrEmpty(previousStep) ? (previousStep as string) : ROUTES.root;
				const index = flowPath.indexOf(prev);
				currentPath = flowPath[index];
				prevPath = flowPath[index - 1];
			}
		}
		logger('### NAVIGATION > BACK', {
			path: currentPath,
		});
		setNavigationStep(currentPath, prevPath);
		history.push(currentPath);
	};

	const gotoHome = () => {
		const url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
		window.location.href = url;
	};

	const navigate = (route: Routes) => {
		const path = ROUTES[route];
		logger('### NAVIGATION > NAVIGATE', { path });
		history.push(path);
		setNavigationStep(path);
	};

	const next = () => {
		let path = !CoreHelper.isNullOrEmpty(currentStep) ? currentStep : ROUTES.root;
		if (flowPath.includes(path)) {
			const index = flowPath.indexOf(path);
			path = flowPath[index + 1];
		}
		logger('### NAVIGATION > NEXT', { path });
		history.push(path);
		setNavigationStep(path, currentStep);
	};

	const conclusionIziBizi = () => {
		let path = !CoreHelper.isNullOrEmpty(currentStep) ? currentStep : ROUTES.root;
		if (flowPath.includes(path)) {
			const index = flowPath.indexOf(path);
			path = flowPath[index + 1];
		}
		logger('### NAVIGATION > CONCLUSION', { path });
		history.replace(path);
		setNavigationStep(path, currentStep);
	};

	const navigateCustomUrl = (url: string) => {
		if (!url.includes('https://') && !url.includes('http://')) {
			url = `${window.location.protocol}//${url}`;
		}
		window.location.href = url;
	};

	const exit = () => {
		const sessionStorage = getSessionStorage('ott');
		let goto = t('general.exit.navigateIzibizi');
		if (sessionStorage !== undefined) {
			goto = t('general.exit.navigateMbcp');
		}
		navigateCustomUrl(goto);
	};

	return {
		back,
		gotoHome,
		navigate,
		next,
		navigateCustomUrl,
		conclusionIziBizi,
		exit,
	};
};
